export default {"src":"/_next/static/media/fire-red.843f42a9.svg","height":21,"width":18,"blurWidth":0,"blurHeight":0};